import * as React from 'react';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
// @mui
import { Popover, Button, Stack, TextField, Container, FormControlLabel, Checkbox } from '@mui/material';

import { getUsuarios, getFluxogramas } from '../../api';

import { useUnidades } from '../../../hooks/useUnidades';

// ----------------------------------------------------------------------

// eslint-disable-next-line no-unused-vars
const PopoverFiltroLeads = React.forwardRef((props, ref) => {
  const [filtro, setFiltro] = useState(props.filtro);

  // Unidades agora vêm do hook (esquema novo, com _id) em vez de config.unidades.
  const { unidades } = useUnidades();

  const [filterOptions, setFilterOptions] = useState({
    usuarios: [],
    etapas: []
  });

  const currentLocation = useLocation();
  const usuarioLogado = JSON.parse(localStorage.getItem('userData'))

  // Carrega os fluxos e as opções dos filtros na montagem
  useEffect(() => {
    const loadInitialData = async () => {
      try {
        const [usuariosData, etapasData] = await Promise.all([
          getUsuarios(),
          getFluxogramas()
        ]);

        setFilterOptions({
          usuarios: usuariosData,
          etapas: etapasData.find(e => e.id === 10).etapas,
        });
      } catch (error) {
        console.error('Erro ao carregar dados iniciais do filtro:', error);
        alert('Erro ao carregar dados do filtro.');
      }
    };
    loadInitialData();
  }, []);

  // Calendario
  const handleDateChange = (e) => {
    setFiltro((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  // Handlers de Filtro
  const handleMultiSelectChange = (filterKey, value) => {
    setFiltro((prev) => ({
      ...prev,
      [filterKey]: prev[filterKey].includes(value)
        ? prev[filterKey].filter((item) => item !== value) // Remove
        : [...prev[filterKey], value], // Adiciona
    }));
  };

  const handleConfirm = () => {
    props.onConfirm(filtro);
  };
  return (
    <Popover
      open={Boolean(props.open)}
      anchorEl={props.open}
      onClose={props.onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{
        sx: {
          p: 1,
          width: 'auto+10',
          height: '100%',
          flex: 1,
          display: 'flex',
          '& .MuiMenuItem-root': {
            px: 1,
            typography: 'body2',
            borderRadius: 0.75,
          },
        },
      }}
    >
      <Stack flex={1} gap={1} sx={{ height: 'auto' }}>

        <Stack direction={'row'} gap={2}>
          <TextField
            name="dataInicio"
            type="date"
            value={filtro.dataInicio}
            onChange={handleDateChange}
            InputLabelProps={{ shrink: true }}
            style={{ marginRight: 10 }}
          />
          <TextField
            name="dataFim"
            type="date"
            value={filtro.dataFim}
            onChange={handleDateChange}
            InputLabelProps={{ shrink: true }}
            style={{ marginRight: 10 }}
          />
        </Stack>


        {/* ⚠️ ATENÇÃO — risco documentado no handoff (seção 3.3):
            filtro.unidades agora carrega _id (esquema novo) em vez do id
            numérico legado. A rota de backend /dadoshomeleads, que consome
            esse filtro no dashboard de Leads, AINDA espera o esquema antigo
            e não foi migrada nesta sessão. Ou seja: este filtro de Unidade
            pode parar de retornar resultados corretos até /dadoshomeleads
            ser ajustada para aceitar _id. Não remover este comentário até
            o backend ser corrigido. */}
        <div className="filter-group">
          <strong className="filter-group-label">Unidade</strong>
          <div className="checkbox-list" >
            {unidades.map((opt) => (
              <FormControlLabel
                key={opt._id}
                control={
                  <Checkbox
                    size="small"
                    checked={filtro.unidades.includes(opt._id)}
                    onChange={() => handleMultiSelectChange('unidades', opt._id)}
                  />
                }
                label={opt.nome}
              />
            ))}
          </div>
        </div>


        <div className="filter-group">
          <strong className="filter-group-label">Usuário</strong>
          <div className="checkbox-list" style={{ minHeight: '200px' }}>
            {filterOptions.usuarios.map((opt) => (
              <FormControlLabel
                key={opt._id}
                control={
                  <Checkbox
                    size="small"
                    checked={filtro.usuarios.includes(opt._id)}
                    onChange={() => handleMultiSelectChange('usuarios', opt._id)}
                  />
                }
                label={opt.nome}
                disabled={currentLocation.pathname === '/leads' && !usuarioLogado.supervisor}
              />
            ))}
          </div>
        </div>

        <div className="filter-group">
          <strong className="filter-group-label">Etapa</strong>
          <div className="checkbox-list" style={{ minHeight: '200px' }}>
            {filterOptions.etapas.map((opt) => (
              <FormControlLabel
                key={opt.id}
                control={
                  <Checkbox
                    size="small"
                    checked={filtro.etapas.includes(opt.id)}
                    onChange={() => handleMultiSelectChange('etapas', opt.id)}
                  />
                }
                label={opt.nome}
              />
            ))}
          </div>
        </div>


        <Container sx={{ marginTop: 2 }}>
          <Stack direction={'row'} justifyContent={'space-between'}>
            <Button variant={'outlined'} onClick={props.onLimpar}>
              Limpar
            </Button>

            <Button variant={'contained'} color={'success'} onClick={handleConfirm}>
              Filtrar
            </Button>
          </Stack>
        </Container>
      </Stack>
    </Popover>
  );
});

PopoverFiltroLeads.propTypes = {
  open: PropTypes.object,
  onClose: PropTypes.func,
  onLimpar: PropTypes.func,
  onConfirm: PropTypes.func,
};

export default PopoverFiltroLeads;